/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export interface IModerationInfo {
  /** Имеет проверенные документы **/
  hasVerifiedDocuments?: TModerationInfo_HasVerifiedDocuments;
  /** Название доверия к пользователю **/
  levelName?: TModerationInfo_LevelName;
  /** Название степени доверия к пользователю **/
  levelOrderName?: TModerationInfo_LevelOrderName;
}

export type TModerationInfo_HasVerifiedDocuments = null | boolean;

export type TModerationInfo_LevelName = null | string;

export type TModerationInfo_LevelOrderName = null | ELevelOrderName;

export enum ELevelOrderName {
  /** Очень высокая степень доверия (level_number=4) **/
  'Gold' = 'gold',
  /** Высокая степень доверия (level_number=3) **/
  'Silver' = 'silver',
}
